<template>
	<mm-tab-title v-model="tab" :titles="titles">
		<div slot="save" v-show="tab===1" >
			<el-button size="medium" type="primary" @click="submit">save</el-button>
		</div>
		<div>
		<div v-show="tab===1">
			<el-form ref="form" :model="result" size="small" label-width="200px">
				
					<el-form-item label="Channel Name" prop="channel_name"  required>
						<el-input v-model="result.channel_name" :readonly="edit" />
					</el-form-item>
					<el-form-item label="Status" prop="status" required>
						<el-radio-group v-model="result.status">
							<el-radio label='active'>active</el-radio>
							<el-radio label='pending'>pending</el-radio>
							<el-radio label='paused'>paused</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="Campaign Budget($)" prop="camp_budget"  required>
						<el-input type="number" @mousewheel.native.prevent v-model="result.camp_budget"/>
					</el-form-item>
                    <el-form-item label="Nice Offer" prop="nice_offer"  required>
						<el-input type="number" @mousewheel.native.prevent v-model="result.nice_offer"/>
					</el-form-item>
                    <el-form-item label="Fresh Offer" prop="fresh_offer"  required>
						<el-input type="number" @mousewheel.native.prevent v-model="result.fresh_offer"/>
					</el-form-item>
					<!-- <el-form-item label="Offer White List" prop="offer_white_list">
                        <el-input v-model="result.offer_white_list" type="textarea" :rows="5" />
					</el-form-item> -->
                    <el-form-item label="Offer Filter Rules">
						<mm-channel-api-filter-rule v-model="result.api_filter_rule" />
					</el-form-item>
                    <el-form-item label="CVR Limit Setting">
                        <mm-adv-rule-offer-cvr-rule v-model="result.camp_cvr_rule" />
					</el-form-item>
					
			</el-form>
        </div>
		<div v-show="tab===2">
			<div class="add-rule">
				<mm-lc title="Adv.">
					<mm-adv-select no_paused v-model="adv_ids" :filter_list="filter_list" multiple/>
				</mm-lc>
				<mm-lc title="Daily Cap">
					<el-input type="number" @mousewheel.native.prevent v-model="daily_cap" size="small"/>
				</mm-lc>
				<mm-lc title="Add Rule">
					<el-button type="primary" size="medium" @click="addRule">Create</el-button>
				</mm-lc>
			</div>
			<div class="rule-table">
			<mm-rule-list ref="rl" apiPath="/advChannelRule/list" :where="where" ruleType="channel"></mm-rule-list>
			</div>
		</div>
		</div>
	</mm-tab-title>

</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		return {
			result:{},
			tab: 1,
			where: {
				channel_id:this.$route.query['id'],
				adv_id: ''
			},
			adv_ids:'',
			daily_cap:'',
			rule_arr:[],
			titles:['Basic Rule','Adv-Channel-Rule'],
			filter_list: [],
		}
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
			const result = await this.$post('/channelRule/update',this.result);
			this.loadData();
            
		},
		async loadData(){
			const id= this.$route.query['id'];
			this.result = await this.$post('/channelRule/detail',{channel_id:id});
		},
		async addRule(){
			if(this.adv_ids.length == 0 || this.daily_cap == 0){
				this.$message({
					type: 'error',
					message: 'type error',
				});
				return;
			}
			let adv = [];
			if(this.adv_ids.$nin != undefined){
				for (const adv_obj of this.$cache.adv_list) {
					if(this.adv_ids.$nin.indexOf(adv_obj.value) == -1){
						adv.push([adv_obj.value,adv_obj.name]);
					}
				}
			}else{
				for (const adv_obj of this.$cache.adv_list) {
					if(this.adv_ids.$in.indexOf(adv_obj.value) != -1){
						adv.push([adv_obj.value,adv_obj.name]);
					}
				}
			}

			const result = await this.$post('/advChannelRule/channelCreate',{channel_id:this.result.channel_id,channel_name:this.result.channel_name,adv:adv,daily_cap:this.daily_cap});
			
			this.$refs.rl.$children[0].refresh();
			// init data & adv select options
			this.adv_ids = '';
			this.daily_cap = '';
			await this.getAllId();
		},
		async getAllId(){
			const id = this.$route.query['id'];
			const result = await this.$post('/advChannelRule/getAllId',{where:{channel_id:id}});
			for(const row of result) {
				this.filter_list.push(row.adv_id);
			}
		},
	},
    
	beforeMount() {
		this.loadData();
		this.getAllId();
	}
};
</script>

<style scoped>
	.add-rule {
		display:flex;
		flex-direction: row;
	}
	.rule-table {
		width: 100%;
		height: 640px;
	}
</style>